var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("a-tabs", {
    staticStyle: {
      height: "100%"
    },
    attrs: {
      activeKey: _vm.activeKey
    },
    on: {
      change: _vm.tabChange
    }
  }, [_c("a-tab-pane", {
    key: "client",
    attrs: {
      tab: _vm.$t("客户端投保")
    }
  }, [_c("client-tab", {
    ref: "client"
  })], 1), _c("a-tab-pane", {
    key: "backManage",
    attrs: {
      tab: _vm.$t("后台管理系统")
    }
  }, [_c("backManageTab", {
    ref: "backManage"
  })], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };